<div class="wrapper">
	<div class="header">
	</div>
	<div class="gantt-wrapper">
		<div class="gantt">
			<div class="gantt__row gantt__row--months header">
				<div class="gantt__row-first space"></div>
				<span class="custom-width-190 text-align-left jobs"> Jobs & Steps</span>
				<span *ngFor="let t of sortedTimestamps; let i = index" [ngStyle]="{'width': barWidth}"
					class="timestamp">
					{{getTimestampToDisplay(t, i)}} </span>
			</div>
			<div class="gantt__row gantt__row--lines custom-margin-left">
				<span></span>
				<span *ngFor="let t of sortedTimestamps; let i = index" [ngStyle]="{'width': barWidth}"
					[style.border-left]="getIndex(i) == 0 ? '' : '1px solid rgba(0, 0, 0, 0.1)'"></span>
			</div>
			<ng-container *ngFor="let t of data; let i=index">
				<div class="gantt__row" *ngIf="!t.job_id || jobId === t.job_id">

					<!-- TODO: add this ng style for heatmap = [ngStyle]="getColor(t.duration)" -->
					<div class="gantt__row-first job_name"
						[ngStyle]="{'padding-left': jobId && jobId === t?.job_id ? '79px':''}">

						<div>
							<mat-icon *ngIf="!t.steps ? false : true" class="cursor icon-container"
								matTooltip="{{ t === selectedItem ? (!selectedItem ? 'Expand' : 'Collapse') : 'Expand' }}"
								(click)="selectedItem = selectedItem ? '' : t; jobId = jobId ? '' : t.id">{{ t ===
								selectedItem ? !selectedItem ? 'add' : 'remove' : 'add'}}</mat-icon>
						</div>
						<span [matTooltip]="t.status">
							<mat-icon *ngIf="t.status === 'success'" class="success-icon">done</mat-icon>
							<mat-icon *ngIf="t.status === 'failed' || t.status === 'failure'"
								class="failure-icon">clear</mat-icon>
							<mat-icon *ngIf="t.status === 'skipped'" class="skip-icon">skip_next</mat-icon>
						</span>
						<span [matTooltip]="getQualityGateTooltip(t.label)">
							<mat-icon *ngIf="isQualityGateSuccess(t.label)"
								class="success-icon">verified_user</mat-icon>
							<mat-icon *ngIf="isQualityGateFail(t.label)" class="failure-icon">privacy_tip</mat-icon>
						</span>

						<span [matTooltip]="t.label" class="label">
							{{t.label}}
						</span>
					</div>
					<ul class="gantt__row-bars" [style.--columnCount]="sortedTimestamps.length">
						<li [matTooltip]="getTooltipText(t)" matTooltipClass="my-tooltip"
							[style.grid-column]="getSpanColumn(t)"
							[ngStyle]="{'padding': t.duration == 2 ? '5px 6px':t.duration == 0 || t.duration == 1 ? '5px 0px':''}"
							[ngClass]="(jobId && jobId === t.job_id) ? 'opacity6':'opacity10'" class="task"
							[class.success]="t.status === 'success'"
							[class.error]="t.status === 'error' || t.status === 'failed' || t.status === 'failure'">
							<div>{{t.duration}}s</div>
						</li>
					</ul>
				</div>
			</ng-container>
		</div>
	</div>
</div>